export const plateBuilder = {
    "plate-size": [
        { size: 'Minimal Car (12x3in)', width: 12, height: 3, value: 1, material: ['Regular', 'Black'], typeOfTransport: ['car'], category: ['show'] },
        { size: 'Minimal Car (12x6in)', width: 12, height: 6, value: 2, material: ['Regular', 'Silver', 'Black', 'Silver Mirror'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true },
        { size: 'Minimal Car (13x4.4in)', width: 13, height: 4.4, value: 3, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['show'],  },
        { size: 'Minimal Car (13x4.5in)', width: 13, height: 4.5, value: 4, material: ['Regular', 'Black'], typeOfTransport: ['car'], category: ['show'] },
        { size: 'Minimal Car (13x6.5in)', width: 13, height: 6.5, value: 5, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true, },
        { size: 'Minimal Car (13x6in)', width: 13, height: 6, value: 6, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true,  },
        { size: 'Minimal Car (13x7in)', width: 13, height: 7, value: 7, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true,  },
        { size: 'Minimal Car (13x8in)', width: 13, height: 8, value: 8, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true,  },
        { size: 'Minimal Car (14x7in)', width: 14, height: 7, value: 9, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true,  },
        { size: 'Oversized Car Oblong (16x4.5in)', width: 16, height: 4.5, value: 10, material: ['Regular', 'Black', 'Silver Mirror','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'],   },
        { size: 'Oversized Car Oblong (20.5x5.5in)', width: 20.5, height: 5.5, value: 11, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'],   },
        { size: 'Oversized Car Oblong (20.5x5in)', width: 20.5, height: 5, value: 12, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'] ,  },
        { size: 'Oversized Car Oblong (20.5x6in)', width: 20.5, height: 6, value: 13, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'],   },
        { size: 'Oversized Car Oblong (21x 6in)', width: 21, height: 6, value: 14, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'] ,  },
        { size: 'Oversized Car Oblong (22x6in)', width: 22, height: 6, value: 15, material: ['Regular', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'],   },
        { size: 'Small Motorcycle (7.5x6in)', width: 7.5, height: 6, value: 16, material: ['Regular', 'Black'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (6.5x6.5in)', width: 6.5, height: 6.5, value: 17, material: ['Regular', 'Black'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (6x4in)', width: 6, height: 4, value: 18, material: ['Regular', 'Silver'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7.5x6.5in)', width: 7.5, height: 6.5, value: 19, material: ['Regular', 'Acrylic', 'Black'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7x5in)', width: 7, height: 5, value: 20, material: ['Regular', 'Silver', 'Silver Mirror', 'Black', 'Acrylic'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7x5.5in)', width: 7, height: 5.5, value: 28, material: ['Regular', 'Silver', 'Black'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (8x2in)', width: 8, height: 2, value: 21, material: ['Regular', 'Black'], typeOfTransport: ['motorbike'], category: ['show'] },
        { size: 'Small Motorcycle (8x6in)', width: 8, height: 6, value: 22, material: ['Regular', 'Acrylic', 'Silver', 'Black', 'Silver Mirror'], typeOfTransport: ['motorbike'], category: ['show'] },
        { size: 'Small Motorcycle (9x2in)', width: 9, height: 2, value: 23, material: ['Regular', 'Acrylic', 'Black'], typeOfTransport: ['motorbike'], category: ['show'] },
        { size: 'Small Motorcycle (9x3in)', width: 9, height: 3, value: 24, material: ['Regular', 'Silver Mirror', 'Black'], typeOfTransport: ['motorbike'], category: ['show'] },
        { size: 'Standard Car Square 4X4 (11x8in)', width: 11, height: 8, value: 25, material: ['Regular', 'Silver', 'Silver Mirror', 'Pressed Metal Black', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'], break: true, },
        { size: 'Standard Car Oblong (20.5x4.4in)', width: 20.5, height: 4.4, value: 26, material: ['Regular', 'Acrylic', 'Silver', 'Pressed Metal', 'Silver Mirror', 'Pressed Metal Black', 'Honeycomb', 'Tinted', 'Black','3D Domed','4D Raised'], typeOfTransport: ['car'], category: ['standard', 'show'] , },
        { size: 'Standard Motorcycle (9x7in)', width: 9, height: 7, value: 27, material: ['Regular', 'Silver', 'Silver Mirror', 'Acrylic', 'Black', 'Flexi','3D Domed','4D Raised'], typeOfTransport: ['motorbike'], category: ['standard', 'show'], break: true, },
        { size: 'Small Motorcycle (6x4in)', width: 6, height: 4, value: 29, material: ['Flexi', 'Black'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7x5in)', width: 7, height: 5, value: 30, material: ['Flexi'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (8x6in)', width: 8, height: 6, value: 31, material: ['Flexi'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7.25x4.25in)', width: 7.25, height: 4.25, value: 33, material: ['Regular'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7x4.25in)', width: 7, height: 4.25, value: 34, material: ['Regular'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Small Motorcycle (7x6in)', width: 7, height: 6, value: 35, material: ['Regular', 'Black'], typeOfTransport: ['motorbike'], category: ['show'], break: true },
        { size: 'Standard Car Square 4X4 (11x8in)', width: 11, height: 8, value: 36, material: ['Acrylic'], typeOfTransport: ['car'], category: ['standard', 'show'], onlyRear: true, },

    ],
    "price": [
        {
            material: 'Acrylic',
            prices: [
                {
                    size: 'Small Motorcycle (7.5x6.5in)',
                    price: 14.99
                },
                {
                    size: 'Small Motorcycle (7x5in)',
                    price: 14.99
                },
                {
                    size: 'Small Motorcycle (8x6in)',
                    price: 14.99
                },
                {
                    size: 'Small Motorcycle (9x2in)',
                    price: 14.99
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 11.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 14.99
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 11.99
                }
            ]
        },
        {
            material: 'Regular',
            prices: [
                {
                    size: 'Minimal Car (12x3in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (12x6in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x4.4in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x4.5in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x6.5in)',
                    price: 11.99
                },
                {
                    size: 'Minimal Car (13x6in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x7in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x8in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (14x7in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (16x4.5in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (20.5x5.5in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (20.5x5in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (20.5x6in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (21x 6in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (22x6in)',
                    price: 16.99
                },
                {
                    size: 'Small Motorcycle (7.5x6in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (6.5x6.5in)',
                    price: 14.99
                },
                {
                    size: 'Small Motorcycle (6x4in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (7.5x6.5in)',
                    price: 14.99
                },
                {
                    size: 'Small Motorcycle (7x5in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (7x5.5in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (8x2in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (8x6in)',
                    price: 14.99
                },
                {
                    size: 'Small Motorcycle (9x2in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (9x3in)',
                    price: 13.99
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 14.99
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 9.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (7.25x4.25in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (7x4.25in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (7x6in)',
                    price: 13.99
                }
            ]
        },
        {
            material: 'Silver',
            prices: [
                {
                    size: 'Minimal Car (12x6in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (6x4in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7x5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7x5.5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (8x6in)',
                    price: 18.5
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 18.5
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 14.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 15.99
                }
            ]
        },
        {
            material: 'Black',
            prices: [
                {
                    size: 'Minimal Car (12x3in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (12x6in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (13x4.4in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (13x4.5in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (13x6.5in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (13x6in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (13x7in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (13x8in)',
                    price: 18.5
                },
                {
                    size: 'Minimal Car (14x7in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (16x4.5in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (20.5x5.5in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (20.5x5in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (20.5x6in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (21x 6in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (22x6in)',
                    price: 19.99
                },
                {
                    size: 'Small Motorcycle (7.5x6in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (6.5x6.5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (6x4in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7.5x6.5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7x5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7x5.5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (8x2in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (8x6in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (9x2in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (9x3in)',
                    price: 18.5
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 18.5
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 14.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7x6in)',
                    price: 18.5
                }
            ]
        },
        {
            material: 'Silver Mirror',
            prices: [
                {
                    size: 'Minimal Car (12x6in)',
                    price: 18.5
                },
                {
                    size: 'Oversized Car Oblong (16x4.5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (7x5in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (9x3in)',
                    price: 17.99
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 15.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 15.99
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 18.5
                },
                {
                    size: 'Small Motorcycle (8x6in)',
                    price: 18.5
                }
            ]
        },
        {
            material: 'Pressed Metal Black',
            prices: [
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 24.99
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 35.0
                }
            ]
        },
        {
            material: 'Tinted',
            prices: [
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 17.99
                }
            ]
        },
        {
            material: 'Flexi',
            prices: [
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 15.99
                },
                {
                    size: 'Small Motorcycle (6x4in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (7x5in)',
                    price: 13.99
                },
                {
                    size: 'Small Motorcycle (8x6in)',
                    price: 13.99
                }
            ]
        },
        {
            material: 'Pressed Metal',
            prices: [
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 21.99
                }
            ]
        },
        {
            material: '3D Domed',
            prices: [
                {
                    size: 'Minimal Car (13x4.4in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x6.5in)',
                    price: 11.99
                },
                {
                    size: 'Minimal Car (13x6in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x7in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x8in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (14x7in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (16x4.5in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (20.5x5.5in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (20.5x5in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (20.5x6in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (21x 6in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (22x6in)',
                    price: 16.99
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 14.99
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 9.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 13.99
                },
            ]
        },
        {
            material: '4D Raised',
            prices: [
                {
                    size: 'Minimal Car (13x4.4in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x6.5in)',
                    price: 11.99
                },
                {
                    size: 'Minimal Car (13x6in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x7in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (13x8in)',
                    price: 14.99
                },
                {
                    size: 'Minimal Car (14x7in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (16x4.5in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (20.5x5.5in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (20.5x5in)',
                    price: 14.99
                },
                {
                    size: 'Oversized Car Oblong (20.5x6in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (21x 6in)',
                    price: 15.49
                },
                {
                    size: 'Oversized Car Oblong (22x6in)',
                    price: 16.99
                },
                {
                    size: 'Standard Car Square 4X4 (11x8in)',
                    price: 14.99
                },
                {
                    size: 'Standard Car Oblong (20.5x4.4in)',
                    price: 9.99
                },
                {
                    size: 'Standard Motorcycle (9x7in)',
                    price: 13.99
                },
            ]
        },
    ],
    "plate-type": [
        { type: 'Regular', category: ['standard', 'show'], typeOfTransport: ['car', 'motorbike'], price: 9.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "true", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Acrylic', category: ['standard', 'show'], typeOfTransport: ['car', 'motorbike'], price: 11.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "true", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Silver', category: ['show'], typeOfTransport: ['car', 'motorbike'], price: 14.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "false", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Black', category: ['show'], typeOfTransport: ['car', 'motorbike'], price: 14.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "false", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Silver Mirror', category: ['show'], typeOfTransport: ['car', 'motorbike'], price: 15.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "false", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Pressed Metal Black', category: ['show'], typeOfTransport: ['car'], price: 24.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "false", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        // { type: 'Honeycomb', category: ['show'], typeOfTransport: ['car'], price: 17.49, image: 'img/materials/HONEYCOMB.jpg', design: "true" },
        { type: 'Tinted', category: ['show'], typeOfTransport: ['car'], price: 17.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "true", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Flexi', category: ['show'], typeOfTransport: ['motorbike'], price: 13.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "true", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: 'Pressed Metal', category: ['show'], typeOfTransport: ['car'], price: 21.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "false", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: '3D Domed', category: ['standard','show'], typeOfTransport: ['car'], price: 9.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "true", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
        { type: '4D Raised', category: ['standard','show'], typeOfTransport: ['car'], price: 9.99, image: 'img/materials/IMAGE_PLACEHOLDER.jpg', design: "true", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a velit elit." },
    ],
    "font-family": [
        { font: 'CharlesWright Bold', name: 'STANDARD',price: 0, typeOfTransport: ['car'], category: ['standard', 'show'], material: ['Regular', 'Acrylic', 'Silver', 'Pressed Metal', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', 'Pressed Metal Black'], slogan: true, image: 'img/font/STANDARD.jpg', },
        { font: 'laser3d webfont', name: '3D Domed', price: 12.00, typeOfTransport: ['car'], slogan: false, category: ['standard', 'show'], material: ['Regular', 'Acrylic', 'Honeycomb', 'Tinted', 'Flexi', '3D Domed'],  image: 'img/font/3DGEL.jpg', },
        { font: 'Dome4D', name: '4D Laser Cut', price: 15.00, typeOfTransport: ['car'], category: ['standard', 'show'], slogan: false, material: ['Regular', 'Acrylic', 'Honeycomb', 'Tinted', 'Flexi', '4D Raised'],  image: 'img/font/4D.jpg', },
        { font: 'Plate3d', name: 'Charles Wright 3D Effect',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: false, material: ['Regular', 'Acrylic', 'Silver', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi'] },
        { font: 'Charles Wright Carbon',price: 0, typeOfTransport: ['car', 'motorbike'], name: 'Charles Wright Carbon', category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi'] },
        { font: 'CharlesWright1935',price: 0, typeOfTransport: ['car', 'motorbike'], name: 'Charles Wright 1935', category: ['show'], material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi'], slogan: true,  },
        { font: 'CharlesWright Motorcycle',price: 0, typeOfTransport: ['motorbike'], name: 'STANDARD MC', slogan: false, category: ['standard', 'show'], material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  image: 'img/font/IMAGE_PLACEHOLDER.jpg', },
        { font: 'Comic Sans', name: 'Comic Sans',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Helvetica', name: 'Helvetica',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Bebas Neue', name: 'Bebas Neue',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ], },
        { font: 'Black Ops One', name: 'Black Ops One',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ], },
        { font: 'Dancing Script', name: 'Dancing Script',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Great Vibes', name: 'Great Vibes',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Lemon', name: 'Lemon',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Lobster', name: 'Lobster', price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Marhey', name: 'Marhey',price: 0, typeOfTransportt: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Pacifico', name: 'Pacifico',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Tektur', name: 'Tektur',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver',  'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Yellowtail', name: 'Yellowtail',price: 0, typeOfTransport: ['car', 'motorbike'], category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
        { font: 'Open Sans', name: 'Open Sans', price: 0,  category: ['show'], slogan: true, material: ['Regular', 'Acrylic', 'Silver', 'Silver Mirror', 'Honeycomb', 'Tinted', 'Black', 'Flexi', ],  },
    ],
    badges: [
        { badge: 'img/badges/badge1.svg', name: 'CYMRU', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge2.svg', name: 'CYMRU ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge3.svg', name: 'ENG', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge4.svg', name: 'ENG ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge5.svg', name: 'ENGLAND', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge6.svg', name: 'ENGLAND ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge7.svg', name: 'NI', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge8.svg', name: 'SCO', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge9.svg', name: 'NI ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge10.svg', name: 'SCO ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge11.svg', name: 'NORTHRN IREALAND', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge12.svg', name: 'SCOTLAND', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge13.svg', name: 'NORTHRN IREALAND ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge14.svg', name: 'SCOTLAND ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge15.svg', name: 'UK', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge16.svg', name: 'UK ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge18.svg', name: 'UNITED KINGDOM ', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge19.svg', name: 'WALES', category: ['standard', 'show'], color: '#2C509E' },
        { badge: 'img/badges/badge20.svg', name: 'WALES ', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_CYMRU_L.svg', name: 'CYMR', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_CYMRU_P.svg', name: 'CYMR', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_ENG_L.svg', name: 'ENG', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_ENG_P.svg', name: 'ENG', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_ENGLAND_L.svg', name: 'ENGLAND', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_ENGLAND_P.svg', name: 'ENGLAND', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_EV_GREEN.svg', name: 'EV ', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_NI_L.svg', name: 'NI', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_NI_P.svg', name: 'NI', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_NORTHERN_IRE_L.svg', name: 'NORTHERN', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_NORTHERN_IRE_P.svg', name: 'NORTHERN', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_SCO_L.svg', name: 'SCO', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_SCO_P.svg', name: 'SCO', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_SCOTLAND_L.svg', name: 'SCOTLAND', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_SCOTLAND_P.svg', name: 'SCOTLAND', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_UK_L.svg', name: 'UK', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_UK_P.svg', name: 'UK', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_UNITED_KINGDOM_L.svg', name: 'UNITED KINGDOM', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_UNITED_KINGDOM_P.svg', name: 'UNITED KINGDOM ', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_WALES_L.svg', name: 'WALES ', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/STANDARD_BADGES_green_BGRND_WALES_P.svg', name: 'WALES ', category: ['standard', 'show'], color: '#00B74F' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_AUSTRAILIA.svg', name: 'AUSTRAILIA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CANADA.svg', name: 'CANADA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CHINA.svg', name: 'CHINA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CORNWALL-P.svg', name: 'CORNWALL', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CORNWALL.svg', name: 'CORNWALL', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_ENGLAND-ROSE.svg', name: 'ENGLAND ROSE', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_GB-EURO.svg', name: 'EURO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_GB-UNION-FLAG.svg', name: 'UNION FLAG', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_GUERNSEY.svg', name: 'GUERNSEY', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_INDIA.svg', name: 'INDIA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_IOM-L.svg', name: 'IOM', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_IOM-p.svg', name: 'IOM', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_IOW.svg', name: 'IOW', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_IRL.svg', name: 'IRL', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_JAMAICA.svg', name: 'JAMAICA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_JAPAN.svg', name: 'JAPAN', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_JERSEY_BLUE.svg', name: 'JERSEY', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_JERSEY_WHITE.svg', name: 'JERSEY', category: ['standard','show'], color: '#FFFFFF' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_JERSEY-GREEN.svg', name: 'JERSEY', category: ['show'], color: '#00B74F' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_PAKISTAN.svg', name: 'PAKISTAN', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_POLAND.svg', name: 'POLAND', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_ROI.svg', name: 'ROI', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_SOUTH-AFRICA.svg', name: 'SOUTH AFRICA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_UK-EURO.svg', name: 'UK EURO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_USA.svg', name: 'USA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_VIKING.svg', name: 'VIKING', category: ['show'], color: '#1D1D1B' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_REAPER.svg', name: 'REAPER', category: ['show'], color: '#1D1D1B' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_PEACE-LINE.svg', name: 'PEACE', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_PEACE.svg', name: 'PEACE', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_ECO.svg', name: 'ECO', category: ['show'], color: '#00B74F' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_DEVIL-RED.svg', name: 'DEVIL', category: ['show'], color: '#F51716' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_DEVIL-BLACK.svg', name: 'DEVIL', category: ['show'], color: '#1D1D1B' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CANNABIS-LEAF.svg', name: 'CANNABIS LEAF', category: ['show'], color: '#019101' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_ANGRY-SHEEP.svg', name: 'ANGRY SHEEP', category: ['show'], color: '#1D1D1B' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CONSERVATIVE.svg', name: 'CONSERVATIVE', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_LABOUR.svg', name: 'LABOUR', category: ['show'], color: '#E4003B' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_LIB-DEM.svg', name: 'LIB DEM', category: ['show'], color: '#F4B51F' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_AQUARIUS.svg', name: 'IRLAQUARIUS', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_AQUARIUS-ICON.svg', name: 'AQUARIUS', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_ARIES.svg', name: 'ARIES', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_ARIES-ICON.svg', name: 'ARIES', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CANCER.svg', name: 'CANCER', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CANCER-ICON.svg', name: 'CANCER', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CAPRICORN.svg', name: 'CAPRICORN', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_CAPRICORN-ICON.svg', name: 'CAPRICORN', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_GEMINI.svg', name: 'GEMINI', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_GEMINI-ICON.svg', name: 'GEMINI', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_LEO.svg', name: 'LEO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_LEO-ICON.svg', name: 'LEO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_LIBRA.svg', name: 'LIBRA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_LIBRA-ICON.svg', name: 'LIBRA', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_PISCES.svg', name: 'PISCES', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_PISCES-ICON.svg', name: 'PISCES', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_SAGITTARIUS.svg', name: 'SAGITTARIUS', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_SAGITTARIUS-ICON.svg', name: 'SAGITTARIUS', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_SCORPIO.svg', name: 'SCORPIO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_SCORPIO-ICON.svg', name: 'SCORPIO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_TAURUS.svg', name: 'TAURUS', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_TAURUS-ICON.svg', name: 'TAURUS', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_VIRGO.svg', name: 'VIRGO', category: ['show'], color: '#2C509E' },
        { badge: 'img/badges/SHOW-PLATES-BADGES_VIRGO-ICON.svg', name: 'VIRGO', category: ['show'], color: '#2C509E' },
    ]
}
